export default __webpack_public_path__ + "static/media/scratchThumbnail.1d4f0203.png";